module.exports = __webpack_public_path__ + "static/media/19.12bad15d.jpeg";